import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { RenewMembershipComponent } from '../../components/renew-membership/renew-membership.component';
import { LoginService } from 'src/app/core/services/login.service';
import { ProfileService } from '../../services/profile.service';
import * as _moment from 'moment';
import { RenewRequestComponent } from 'src/app/modules/sign-up/components/renew-request/renew-request.component';
import {
  StripeCardElementOptions,
  StripeElementsOptions,
  PaymentIntent,
} from '@stripe/stripe-js';
import { StripeService, StripeCardNumberComponent, StripeCardExpiryComponent, StripeCardCvcComponent } from 'ngx-stripe';
import { SubscriptionPlansService } from 'src/app/modules/home/services/subscription-plans.service';
import { MatTableDataSource } from '@angular/material/table';
import { SignupPlanPaymentsComponent } from 'src/app/modules/sign-up/components/signup-plan-payments/signup-plan-payments.component';
import { UpgradePlanModalComponent } from 'src/app/modules/dashboard/modules/clients/pages/upgrademodal/upgrade-plan-modal.component';
import { ClientsService } from 'src/app/modules/dashboard/modules/clients/services/clients.service';
import { CatalogueService } from 'src/app/modules/dashboard/modules/my-catalogues/services/catalogue.service';
import { AlertModalComponent } from 'src/app/shared/modules/components/alert-modal/alert-modal.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SignupPaymentSuccessComponent } from 'src/app/modules/sign-up/components/signup-payment-success/signup-payment-success.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/core/toast.service';
import { NextTabService } from 'src/app/modules/sign-up/services/next-tab.service';
@Component({
  selector: 'app-membership',
  templateUrl: './membership.component.html',
  styleUrls: ['./membership.component.scss']
})
export class MembershipComponent implements OnInit {
  isUpgradeLoading = false;
    isLoading = false;
billingType : any;
  // isActive = false;
  loginDetails: any;
  userSubscriptions: any;
  subscriptionDisplayedColumns: string[] = [
    'sNo',
    'planName',
    'planPrice',
    'startDate',
    'endDate',
     'invoiceId',
    'status',   
    'action'
  ];
  subObj = {
    dental_supplier_id: null,
    dental_professional_id: null,
    dental_practice_id: null,
    subscription_plan_id: null,
    //client_id:null,
    //tenure_in_days:null,
    starts_at: null,
    expires_at: null,
    //status:null,
    plan_type: null,
    total_amount: null
  }
  dataSource = new MatTableDataSource<any>();
  subPlanDetails: any;
  userPrice: string;
  priceEx: string;
  currentSubscription: any;
  current_subscription_id: any;
  userSubscriptionsUpgrade: any;
  constructor(
    private _dialog: MatDialog,
    private loginService: LoginService,
    private stripeService: StripeService,
    private clientsService:ClientsService,
    private subscriptionPlansService: SubscriptionPlansService,
    private profileService: ProfileService,
    private catalogueService: CatalogueService,
    private spinner: NgxSpinnerService,
    private toast: ToastService,
    private nextTabService: NextTabService,
      private http: HttpClient 
  ) { }
  ngOnInit(): void {
    this.loginDetails = this.loginService.getLoginData();
    if (!this.loginDetails.payment_completed) {
      //this.openUpdateCardModalFromPlans();
    }
    this.subPlanList();

  }

  private openUpdateCardModalFromPlans(): void {
    this.subscriptionPlansService.getSubPlanById(this.loginDetails.plan_id?this.loginDetails.plan_id:this.loginDetails.subscription_id).subscribe(data => {
      this.subPlanDetails = data;
      console.log("billingType", this.billingType)
      console.log()
      if (this.subPlanDetails && this.subPlanDetails.monthy_price > 0) {
        this.userPrice = localStorage.getItem('selPrice');
        this.priceEx = localStorage.getItem('disValue');
        
        this._dialog.open(SignupPlanPaymentsComponent, {
          width: '30%',
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          disableClose: true,
          data: {
            leadId: this.loginDetails.id,
            billingType: this.billingType,
            planDetails: this.subPlanDetails,
            type: "addcard"
          }
        });
      } else {
        console.log("Free plan detected → no popup opened.");
      }
    });
    // const currentPlan = this.allPlans.find(p => p.id === this.loginDetails.subscription_id);
    // console.log("currentPlan", currentPlan)
    }


  subPlanList(): void{
    this.profileService.getuserSub(this.loginDetails.id).subscribe(data => {
      console.log(data)
      this.userSubscriptions = data
      console.log(" this.userSubscriptions",  this.userSubscriptions)
      if(this.userSubscriptions.length > 0) {
        this.userSubscriptions = this.userSubscriptions.sort(function (a, b) {
          //return b.created_at.getTime() - a.created_at.getTime();
          var c: any = new Date(a.created_at);
          var d: any = new Date(b.created_at);
          return d - c;
        });
        for (let one of this.userSubscriptions) {
          const renewTime = _moment(one.expires_at).toDate().getTime()
          console.log(renewTime)
          if (renewTime >= new Date().getTime()) {
            one.showActive = true
          } else {
            one.showActive = false;
          }
        }
        console.log(this.userSubscriptions)
        //this.currentPlan = this.userSubscriptions[
        for (let single of this.userSubscriptions) {
          const renewTime = _moment(single.expires_at).add(-10, 'd').toDate().getTime()
          if (new Date().getTime() > renewTime) {
            single.open = true
          }
        }
        this.dataSource.data = this.userSubscriptions;
        this.currentSubscription = this.userSubscriptions[0];
        this.current_subscription_id = this.loginDetails.plan_id;
        console.log("this.currentSubscription", this.currentSubscription);
      } else {
        this.subscriptionPlansService.getSubPlanById(this.loginDetails.subscription_id).subscribe(data => {
          this.currentSubscription = data;
          this.current_subscription_id = this.loginDetails.subscription_id;
          this.loginDetails.plan_id = this.loginDetails.subscription_id;
          console.log("this.currentSubscription12", this.currentSubscription);
        });
      }
      // console.log(this.currentPlan.expires_at.toLocaleString() )
      // console.log(mm)
      // if(new Date().getTime() > mm){
      //   this._dialog.open(RenewRequestComponent, {
      //     width: '40%',
      //     panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      //     disableClose: true
      //   })
      // }
    })
  }
  renew(): void {
    // this._dialog.open(RenewRequestComponent, {
    //   width: '30%',
    //   panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    // });
    this.subscriptionPlansService.getSubPlanById(this.current_subscription_id).subscribe(data => {
      this.subPlanDetails = data
      this.userPrice = localStorage.getItem('selPrice');
      this.priceEx = localStorage.getItem('disValue');
      // this.subPlanDetails.price_in_aud = JSON.parse(this.userPrice)
      // this.subPlanDetails.priceExten = this.priceEx
      console.log("this.subPlanDetails", this.subPlanDetails);
        console.log("billingType", this.billingType)
      if(this.subPlanDetails.monthy_price > 0) {
        const dialogRef = this._dialog.open(SignupPlanPaymentsComponent, {
            width: '30%',
            panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
            disableClose: true,
            data: {
              leadId: this.loginDetails.id,
              billingType: this.billingType,
              planDetails: this.subPlanDetails,
              type: "addcard"
            }
          });
          dialogRef.afterClosed().subscribe(() => {
            this.subPlanList(); // custom method to re-fetch data in parent component
          });
        } else {
          this.addFreeSubscription(this.subPlanDetails);
        }
    });
  }

  update_card(): void {

    this.subscriptionPlansService.getSubPlanById(this.loginDetails.plan_id).subscribe(data => {
      this.subPlanDetails = data
      this.userPrice = localStorage.getItem('selPrice');
      this.priceEx = localStorage.getItem('disValue');
      // this.subPlanDetails.price_in_aud = JSON.parse(this.userPrice)
      // this.subPlanDetails.priceExten = this.priceEx
      console.log("this.subPlanDetails", this.subPlanDetails);
        console.log("billingType", this.billingType)
      this._dialog.open(SignupPlanPaymentsComponent, {
          width: '30%',
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          disableClose: true,
          data: {
            leadId: this.loginDetails.id,
            billingType: this.billingType,
            planDetails: this.subPlanDetails,
            type: "updatecard"
          }
        });
    });
  }

  applyFilter(value: string) {
    if (this.dataSource) {
      this.dataSource.filter = value.trim().toLowerCase();
    }
  }

  isActive(expiresAt: string | Date): boolean {
    return new Date(expiresAt) > new Date();
  }

  openUpgradeModal(): void {
if (this.isUpgradeLoading) return;
  this.isUpgradeLoading = true;
    console.log("openUpgradeModal", this.userSubscriptions);
    this.subscriptionPlansService.getSubPlanById(this.loginDetails.plan_id?this.loginDetails.plan_id:this.loginDetails.subscription_id).subscribe(data=>{
             
      this.userSubscriptionsUpgrade = data
      
      // this.userSubscriptions = this.userSubscriptions.sort(function (a, b) {
      //   //return b.created_at.getTime() - a.created_at.getTime();
      //   var c:any = new Date(a.created_at);
      //       var d:any = new Date(b.created_at);
      //       return d-c;
      // });
      const dialogRef = this._dialog.open(UpgradePlanModalComponent, {
        panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
        width: '400px',
        data:this.userSubscriptionsUpgrade,
        disableClose: false
      });
      
      dialogRef.afterClosed().subscribe(result => {
        
        if (result) {
          console.log('Upgrade result:', result);
          this.billingType = result.billingType;
          this.current_subscription_id = result.selectedPlan.id;
          if(result.selectedPlan.monthy_price > 0) {
            this.renew();
          } else {
            this.addFreeSubscription(result.selectedPlan)
          }
           this.subPlanList();
        }
          this.isUpgradeLoading = false;
      });

    })
  }

async addFreeSubscription(selectedPlan) {
  this.spinner.show()
  if (this.loginDetails.type == "PROFESSIONAL") {

    this.subObj.dental_professional_id = this.loginDetails.id

    delete this.subObj.dental_supplier_id
    delete this.subObj.dental_practice_id


  }

  if (this.loginDetails.type == "SUPPLIER") {

    this.subObj.dental_supplier_id = this.loginDetails.id

    delete this.subObj.dental_professional_id
    delete this.subObj.dental_practice_id


  }

  if (this.loginDetails.type == "PRACTICE") {

    this.subObj.dental_practice_id = this.loginDetails.id

    delete this.subObj.dental_supplier_id
    delete this.subObj.dental_professional_id

  }

  this.subObj.subscription_plan_id = selectedPlan.id

  this.subObj.starts_at = _moment().toDate();
  this.subObj.expires_at = _moment().add(selectedPlan.tenure_in_days == 0?365:selectedPlan.tenure_in_days, 'd').toDate();
  //this.subObj.status =  "PENDING"
  this.subObj.plan_type = selectedPlan.plan_type
  this.subObj.total_amount = selectedPlan.monthy_price ? selectedPlan.monthy_price : 0;

  try {
    this.loginService.updateLoginData({
      payment_completed: true,
      plan_id: selectedPlan.id
    });


  console.log("Updated loginData:", this.loginService.getLoginData());

  if (this.loginDetails.type == "PROFESSIONAL") {

    this.nextTabService.updateProfessionalStripe(this.loginDetails.id, "Free", selectedPlan.id)
      .subscribe(res => console.log('Professional Stripe ID Updated:', res));
  }

  if (this.loginDetails.type == "SUPPLIER") {
    this.nextTabService.updateSupplierStripe(this.loginDetails.id, "Free", selectedPlan.id)
      .subscribe(res => console.log('Supplier Stripe ID Updated:', res));
  }

  if (this.loginDetails.type == "PRACTICE") {
    this.nextTabService.updatePracticeStripe(this.loginDetails.id, "Free", selectedPlan.id)
      .subscribe(res => console.log('Practice Stripe ID Updated:', res));
  }
  const response = await this.catalogueService.addNextSub({
    ...this.subObj,
    stripe_subscription_id: "Free",
    payment_intent: null,
    plan_status: "ACTIVE"
  }).toPromise();
  console.log("✅ Payment + Subscription Response:", response); // <-- log here
  this._dialog.open(SignupPaymentSuccessComponent, {
    panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    width: '30%'
  });
    this.spinner.hide();
  } catch (error: any) {
    console.error(error);
    this.toast.openSnackBar('Payment failed. Try again.');
    this.spinner.hide();
  }
}

async cancelSubscription() {
  // 🔔 Open confirm modal instead of confirm()
  const dialogRef = this._dialog.open(AlertModalComponent, {
    panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    width: '500px',
    data: {
      title: 'Cancel Subscription',
      message: 'Are you sure you want to cancel your subscription?',
      type: 'confirm',
      confirmText: 'Yes, Cancel',
      cancelText: 'No'
    }
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (!result) {
      // ❌ User cancelled
      return;
    }

    // ✅ User confirmed → Call API
    this.catalogueService
      .cancelSubscription(this.currentSubscription.stripe_subscription_id)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this._dialog.open(AlertModalComponent, {
              panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
              width: '500px',
              data: {
                title: 'Subscription Cancelled',
                message:
                  'Subscription canceled successfully! You can still access it until the end of the billing cycle.',
                type: 'success'
              }
            });
            // this.loadSubscriptionDetails(); // 🔄 Refresh UI if needed
          } else {
            this._dialog.open(AlertModalComponent, {
              panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
              width: '500px',
              data: {
                title: 'Error',
                message: 'Failed to cancel subscription: ' + res.message,
                type: 'error'
              }
            });
          }
        },
        error: (err) => {
          console.error('Error:', err);
          this._dialog.open(AlertModalComponent, {
            panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
            width: '500px',
            data: {
              title: 'Error',
              message: 'Something went wrong while canceling subscription.',
              type: 'error'
            }
          });
        }
      });
  });
}

/** 16-09-2025 */
handleInvoice(element: any, type: 'email' | 'download'): void {
  if (!element?.id) {
    console.error("Invoice ID missing for this row:", element);
    this._dialog.open(AlertModalComponent, {
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      width: '400px',
      data: {
        title: 'Error',
        message: 'No Invoice ID found for this subscription.',
        type: 'error'
      }
    });
    return;
  }

  const payload = {
    id: element.id,         // Invoice ID
    reportType: type        // 'email' or 'download'
  };

  console.log("Sending payload:", payload);
   this.isLoading = true;
  this.http.post<any>(environment.serverPath + '/api/v1/auth/send-invoice-email-Download', payload)
    .subscribe({
      next: (res) => {
        console.log(`Invoice ${type} response:`, res);
 this.isLoading = false;
        this._dialog.open(AlertModalComponent, {
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          width: '400px',
          data: {
            title: 'Success',
            message: type === 'email'
              ? 'Invoice email sent successfully!'
              : 'Invoice downloaded successfully!',
            type: 'success'
          }
        });

        // If it's download → open file
        if (type === 'download' && res?.fileUrl) {
          window.open(res.fileUrl, '_blank');
        }
      },
      error: (err) => {
        console.error(`Error processing invoice ${type}:`, err);
      this.isLoading = false;
        this._dialog.open(AlertModalComponent, {
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          width: '400px',
          data: {
            title: 'Error',
            message: `Failed to ${type} invoice.`,
            type: 'error'
          }
        });
      }
    });
}


}
